var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",attrs:{"alt":"David Vasco logo","src":require("@/assets/logo.png"),"draggable":"false"}})}
var staticRenderFns = []

export { render, staticRenderFns }